import { trackFooterClick } from '@ecomm/cdp-tracking/footerEvents'
import { isSmbMVP } from '@ecomm/data-env-variables'
import type { FooterMenu, trackingEventSchema } from '@ecomm/footer-data'
import { Link } from '@ecomm/framework/Link'
import { ChevronDown } from '@ecomm/shared-icons'
import type { Z } from '@simplisafe/ewok'
import classNames from 'classnames'
import { useState } from 'react'
import { useTracking } from 'react-tracking'

type FooterLink = FooterMenu['linksCollection']['items'][number]
// TODO: Delete this after the SMB header toggle development is finished
const filterItems = (i: FooterLink) => i.url !== '/business' || isSmbMVP

export function FooterCollapsible({
  menu
}: {
  readonly menu: FooterMenu
}) {
  const [show, setShow] = useState(false)
  const { trackEvent } = useTracking<{
    readonly event: Z.infer<typeof trackingEventSchema>
  }>()

  const handleClick = (link: FooterLink) => () => {
    link.trackingEvent &&
      trackEvent({
        event: link.trackingEvent
      })

    trackFooterClick({ selection: link.text })
  }

  return (
    <>
      <button
        className="group inline-flex cursor-pointer items-center gap-2 border-none bg-inherit p-0 text-base font-medium text-white md:cursor-default md:text-lg"
        onClick={() => {
          setShow(prev => !prev)
        }}
      >
        {menu.title}
        <ChevronDown
          className={classNames(
            'mt-1 h-4 w-4 transition-transform duration-200 md:hidden',
            {
              'rotate-180': show,
              'rotate-0': !show
            }
          )}
        />
      </button>
      <ul
        className={classNames('mt-2 list-none p-0 md:block', { hidden: !show })}
      >
        {menu.linksCollection.items.filter(filterItems).map(link => (
          <li
            className="py-2"
            key={`footer_menus_collapsible_${link.text}${link.url}`}
          >
            {link.url?.startsWith('/') ? (
              <Link
                className="text-white no-underline hover:underline"
                onClick={handleClick(link)}
                to={link.url}
              >
                {link.text}
              </Link>
            ) : (
              <a
                className="text-white no-underline hover:underline"
                href={link.url ?? ''}
                onClick={handleClick(link)}
              >
                {link.text}
              </a>
            )}
          </li>
        ))}
      </ul>
    </>
  )
}
